<template>
    <div class="text-muted text-center mt-5 small">
    Powered by | <strong>ComplyOn</strong>
    </div>
</template>
<script>
    export default{
        name:'AiFooter'
    }
</script>